import React from 'react';
import { CgClose } from 'react-icons/cg';

interface InactiveButtonProps { }

const InactiveButton: React.FunctionComponent<InactiveButtonProps> = (props) => {
  return (
    <div className="inactive-button center-content-col" style={{ width: "100%" }}>
      <CgClose className="primary-text-color w-6 h-6" />
    </div>
  );
};

export default InactiveButton;
